import React from 'react';
import './css/MaintenanceScreen.css';

const MaintenanceScreen = () => (
  <div className="ms-wrap">
    <p className="ms-title">App is being upgraded to enhance usage experience</p>
    <div className="ms-video-box">
      <video
        className="ms-video"
        src="/maintenance.mp4"
        autoPlay
        loop
        muted
        playsInline
      />
    </div>
  </div>
);

export default MaintenanceScreen;
